// When the app is accessed via an ngrok tunnel, the free plan shows an
// interstitial warning page for every request that lacks this header.
// Adding it makes ngrok forward the request directly without interruption.
const isNgrok = window.location.hostname.endsWith('.ngrok-free.app') ||
                window.location.hostname.endsWith('.ngrok.io') ||
                window.location.hostname.endsWith('.ngrok-free.dev');

const ngrokHeaders = isNgrok ? { 'ngrok-skip-browser-warning': 'true' } : {};

export default function apiFetch(url, options = {}) {
  return fetch(url, {
    ...options,
    headers: { ...ngrokHeaders, ...options.headers },
  });
}
